import { StyleSheet, Text, View } from "react-native";

import { ChartData } from 'chart.js';
import 'chart.js/auto';
import { Pie } from "react-chartjs-2";

import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more-dashboard.svg';
import DashboardBox from "../../base/tamplate/DashboardBox";
import { FONT } from "../../../value/staticValues";

interface PieChartProps { 
    navigate?: Function;
    url?: string;
    title: string;
    data: number;
    total: number;
    chartData: ChartData<'pie'>;
    color: string;  
}
export default function PieChart(props:PieChartProps) {
    const PieChartOption = {
        cutout: '35%',
        plugins: {
            responsive: true,
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false
            }
        }
    }

    return (
        <DashboardBox style={{
            width: 330, height: 320,
            marginRight: 10,
        }}>
            <View style={{alignItems: "center"}}>
                <View style={{flexDirection: "row", alignItems: "center", width: "100%", height: 20}}>
                    <Text style={{
                        fontFamily: FONT.MEDIUM,
                        fontSize: 14,
                        lineHeight: 13,
                        color: "#262626"
                    }}>
                        {props.title}
                    </Text>
                    {props.url && props.navigate?
                        <MoreImg 
                            style={{marginLeft: "auto", cursor: "pointer"}}
                            onClick={() => {if(props.navigate) props.navigate(`${props.url}`);}}
                        />
                    :null }
                </View>
                <View style={{
                    flexDirection: "row",
                    marginTop: 36,
                }}>
                    <View style={{alignItems: "center"}}>
                        <View style={{width: 140, height: 140}}>
                            <Pie data={props.chartData} options={PieChartOption}/>
                        </View>
                        <View style={{flexDirection: "row", alignItems: "flex-end", marginTop: 20}}>
                            <Text style={{
                                marginBottom: 10,
                                fontFamily: FONT.REGULAR,
                                fontSize: 10,
                                color: "#808080"
                            }}>
                                Total
                            </Text>
                            <Text style={{
                                marginLeft: 5,
                                fontFamily: FONT.BOLD,
                                fontSize: 32,
                                color: "#333"
                            }}>
                                {props.total}
                            </Text>
                        </View>
                    </View>
                    <View style={{marginLeft: 35}}>
                        {props.chartData.labels?.map((item:unknown, index) => {
                            return (
                                <View key={index} style={{flexDirection: "row", alignItems: "center", width: 100, marginBottom: 16}}>
                                    <View style={{
                                        ...styles.LabelBox,
                                        backgroundColor: typeof props.chartData.datasets[0].backgroundColor === 'object' ? props.chartData.datasets[0].backgroundColor[index] + "59" : ""
                                    }}>
                                        <Text style={{
                                            ...styles.LabelText,
                                            color: typeof props.chartData.datasets[0].hoverBackgroundColor === 'object' ? props.chartData.datasets[0].hoverBackgroundColor[index] : ""
                                        }}>
                                            {typeof item === "string" ? item : null}
                                        </Text>
                                    </View>
                                    <Text style={styles.DataText}>
                                        {props.chartData.datasets[0].data[index]}
                                    </Text>
                                </View>
                            )
                        })}
                    </View>
                </View>
            </View>
        </DashboardBox>
    )
}

const styles = StyleSheet.create({
    LabelBox: {
        alignItems: "center", justifyContent: "center",
        minWidth: 45, height: 20,
        marginRight: 10,
        paddingHorizontal: 10, paddingVertical: 5,
        borderRadius: 5,
        backgroundColor: "#e6ebf2"
    },
    LabelText: {
        fontFamily: FONT.MEDIUM,
        fontSize: 12,
        lineHeight: 10,
        color: "#5b9782"
    },
    DataText: {
        marginLeft: "auto",
        fontFamily: FONT.REGULAR,
        fontSize: 14,
        color: "#3a3b3f"
    }
})